<div
    class="counter"
    *ngIf="stage && cmsParams && contentService.valueExists(cmsKey) | async"
    [innerHTML]="cmsKey | cmsText: cmsParams | jpText | async"
></div>
